import React, { useState} from 'react';
import I18n from '../../languages/I18n';

import LanguagesSmall from './LanguagesSmall';
import Languages from './Languages';

const HeaderApp = props => {
  
  const [menuVisible, setMenuVisible] = useState(false);

  if (!props.isSmall) {
    return (
      <>
        <div
          style={{
            height: 110,
            width: '100%',
            backgroundColor: '#fff',
            color: '#333',
            fontSize: 18,
            paddingTop: 7,
          }}>
          <div style={{display: 'flex'}}>
            <img
              alt="kalilo"
              src={require('../../assets/ico-kalilo.png')}
              style={{height: 75, marginLeft: 20, marginTop: 5}}
            />

            <img
              alt="logo"
              src={require('../../assets/ico-kalilotitre.png')}
              style={{height: 80, marginLeft: 7}}
            />

            <div style={{flex: 1}}></div>

            <div style={{marginRight: 20, marginTop: 10}}>
              <LanguagesSmall
                changeLanguage={props.changeLanguage}
                language={props.language}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        style={{
          height: 110,
          width: '100%',
          backgroundColor: '#fff',
          color: '#333',
          fontSize: 18,
          paddingTop: 7,
        }}>
        <div style={{display: 'flex'}}>
          <img
            alt="kalilo"
            src={require('../../assets/ico-kalilo.png')}
            style={{height: 80, marginLeft: 20, marginTop: 6}}
          />

          <div style={{flex: 1, textAlign: 'center'}} />
          <div
            style={{
              height: '100%',
              paddingTop: 35,
              paddingRight: 20,
            }}
            onClick={() => setMenuVisible(true)}>
            <img
              alt="menu"
              style={{width: 40}}
              src={require('../../assets/icons/set_ico-list.png')}
            />
          </div>
        </div>
      </div>

      {menuVisible && (
        <>
          <div
            className="animatedfast fadeIn hidescrollbar"
            style={{
              backgroundColor: '#010101',
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1000,
              overflowY: 'scroll',
              boxSizing: 'border-box',
              padding: 30,
              paddingTop: 130,
            }}>
            <div
              style={{
                fontSize: 28,
                marginBottom: 10,
                color: '#fff',
                fontWeight: 'bold',
              }}>
              {I18n.t('settings.choose_language')}
            </div>

            <Languages
              changeLanguage={props.changeLanguage}
              language={props.language}
            />
          </div>

          <img
            alt="kalilo"
            src={require('../../assets/ico-kalilo.png')}
            style={{
              height: 80,
              position: 'absolute',
              top: 13,
              left: 20,
              zIndex: 1001,
            }}
          />

          <div
            onClick={() => setMenuVisible(false)}
            style={{
              position: 'absolute',
              top: 20,
              right: 10,
              color: '#fff',
              fontSize: 18,
              textAlign: 'center',
              zIndex: 1001,
            }}>
            <img
              src={require('../../assets/icons/ico_remove.png')}
              style={{width: 60, height: 60}}
              alt="close"
            />
          </div>
        </>
      )}
    </>
  );
};

export default HeaderApp;
